import React from "react";
import { Field, ErrorMessage } from "formik";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { civilityOptions, commonStyles } from "./types";

interface PersonalInfoSectionProps {
  setFieldValue: (field: string, value: any) => void;
}

export const PersonalInfoSection: React.FC<PersonalInfoSectionProps> = ({ setFieldValue }) => {
  const { inputClassName, labelClassName, errorClassName } = commonStyles;

  const monthNavigatorTemplate = (e: any) => {
    return (
      <Dropdown
        value={e.value}
        options={e.options}
        onChange={(event) => e.onChange(event.originalEvent, event.value)}
        style={{ lineHeight: 1 }}
      />
    );
  };

  const yearNavigatorTemplate = (e: any) => {
    return (
      <Dropdown
        value={e.value}
        options={e.options}
        onChange={(event) => e.onChange(event.originalEvent, event.value)}
        className="p-ml-2"
        style={{ lineHeight: 1 }}
      />
    );
  };

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
        <div className="field">
          <label htmlFor="name" className={labelClassName}>
            Nom
          </label>
          <Field name="name" as={InputText} className={inputClassName} />
          <ErrorMessage
            name="name"
            component="small"
            className={errorClassName}
          />
        </div>
        <div className="field">
          <label htmlFor="lastName" className={labelClassName}>
            Prénom
          </label>
          <Field
            name="lastName"
            as={InputText}
            className={inputClassName}
          />
          <ErrorMessage
            name="lastName"
            component="small"
            className={errorClassName}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 md:gap-8">
        <div className="field">
          <label htmlFor="civility" className={labelClassName}>
            Civilité
          </label>
          <Field name="civility">
            {({ field }: any) => (
              <Dropdown
                id="civility"
                value={field.value}
                options={civilityOptions}
                onChange={(e) => setFieldValue("civility", e.value)}
                className={inputClassName + " py-[0.3rem]"}
                placeholder="Sélectionnez une civilité"
              />
            )}
          </Field>
          <ErrorMessage
            name="civility"
            component="small"
            className={errorClassName}
          />
        </div>

        <div className="field">
          <label htmlFor="birthDate" className={labelClassName}>
            Date de Naissance
          </label>
          <Field name="birthDate">
            {({ field }: any) => (
              <Calendar
                id="birthDate"
                value={field.value}
                onChange={(e) => setFieldValue("birthDate", e.value)}
                dateFormat="dd/mm/yy"
                showIcon
                className={`${inputClassName} py-0`}
                inputClassName="w-full p-inputtext-md rounded-s-lg py-3 font-sans"
                monthNavigator
                yearNavigator
                yearRange="1930:2015"
                yearNavigatorTemplate={yearNavigatorTemplate}
                monthNavigatorTemplate={monthNavigatorTemplate}
                locale="fr"
              />
            )}
          </Field>
          <ErrorMessage
            name="birthDate"
            component="small"
            className={errorClassName}
          />
        </div>
      </div>
    </>
  );
};
